import React from 'react';
import { ReactComponent as Icon } from './../../../../asset/icons/resident.svg';

const IconResident = () => {
  return <Icon></Icon>;
};

export default IconResident;
